<template>
  <div>
    <div class="tab-pane-body-live">
      <div class="body-header">
        <el-button size="medium" type="primary" icon="iconfont icon-tianjiacaidan1"  @click="addLive" v-if="userPermissions.indexOf('course_live') != -1">添加直播</el-button>
      </div>
      <div class="body-content">
        <el-tree
          :data="liveList"
          node-key="unique_key"
          :highlight-current="true"
          :expand-on-click-node="false"
          default-expand-all
          draggable
          :allow-drop="handleLiveAllowDrop"
          @node-drop="handleLiveNodeDrop">
          <div class="live-tree-node" slot-scope="{node,data}">
            <div class="live-node">
              <span>{{data.identify_key}}</span> 
              <span>{{data.title}}</span>
              <span class="live-time-tag">开始时间：{{data.start_time}}</span>
              <span class="live-time-tag">结束时间：{{data.end_time}}</span>
              <div class="right">
                <ApeButton name="直播信息" type="primary" size="mini" icon="icon-zhibo2" permission="course_live" @click="getLiveStreamInfo(data.id)" plain></ApeButton>
                <ApeButton name="编辑" type="primary" size="mini" icon="el-icon-edit" permission="course_live" @click="editLive(data.id)"></ApeButton>
                <el-popover
                  placement="top"
                  width="150"
                  v-model="data.visible">
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0;">
                    <el-button type="text" size="mini" @click="data.visible=false">取消</el-button>
                    <el-button type="danger" size="mini" @click="deleteLive(data.id)">确定</el-button>
                  </div>
                  <ApeButton slot="reference" name="删除" type="danger" size="mini" icon="el-icon-delete" permission="course_live"></ApeButton>
                </el-popover>
              </div>
            </div>
          </div>
        </el-tree>
      </div>
    </div>
    <ApeDrawer :drawerData="liveDrawerData"  @drawerClose="liveDrawerClose" @drawerConfirm="liveDrawerConfirm">
      <template slot="ape-drawer">
        <el-form :model="liveFormData" :rules="liveRules" ref="liveForm" label-position="right" label-width="96px">
          <el-row>
            <el-col :span="22">
              <el-form-item label="标题" prop="title">
                <el-input v-model="liveFormData.title"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="封面" prop="cover">
                <ApeUploader :limit="1" @handleUploadSuccess="handleLiveUploadSuccess" @handleUploadRemove="handleLiveUploadRemove" :upload-file-list="uploadLiveFileList"></ApeUploader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="讲师" prop="mobile_alias">
                <el-autocomplete
                  class="live-lecturer-user"
                  v-model="liveFormData.mobile_alias"
                  :fetch-suggestions="searchLecturer"
                  placeholder="输入手机号检索用户"
                  @select="handleLecturerSelect"
                  @clear="initMobileVerify"
                  clearable>
                </el-autocomplete>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="直播时间" prop="time_value">
                <el-date-picker
                  class="live-datetimerange"
                  v-model="liveFormData.time_value"
                  type="datetimerange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd HH:mm:ss">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="22">
              <el-form-item label="简介" prop="intro">
                <el-input type="textarea" :rows="6" v-model="liveFormData.intro"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>     
      </template>
    </ApeDrawer>
    <ModalDialog :dialogData="dialogliveStreamData" @dialogConfirm="dialogliveStreamButton" @dialogClose="dialogliveStreamButton">
      <template slot="content">
        <div class="live-stream">
          <span>推流地址</span>
          <span>{{liveStreamInfo.push_info}}</span>
        </div>
        <div class="live-stream">
          <span>观看地址</span>
          <span>{{liveStreamInfo.play_path}}</span>
        </div>
        <div class="live-stream">
          <span>播流地址</span>
          <div>
            <span v-for="playInfo in liveStreamInfo.play_info" :key="playInfo">{{playInfo}}</span>
          </div>
        </div>
      </template>
    </ModalDialog>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import ApeDrawer from '@/components/ApeDrawer'
import ModalDialog from '@/components/ModalDialog'
import ApeUploader from '@/components/ApeUploader'
import ApeButton from '@/components/ApeButton'
import { mapGetters } from 'vuex'

export default {
  components: {
    ApeDrawer,
    ModalDialog,
    ApeUploader,
    ApeButton
  },
  props: {
    // 课程id
    courseId: {
      type: String,
      default() {
        return '0'
      }
    },
  },
  // 定义属性
  data() {
    return {
      // 直播
      liveList:[],
      // 直播信息,抽屉数据
      liveDrawerData: {
        visible: false,
        loading: true,
        loading_text: '玩命加载中……',
        // direction: 'right',
        title: '直播添加',
        width_height: '640px',
        // mask: false,
        // close_name: '关 闭',
        // confirm_name: '打 印',
      },
      // 直播信息表单结构
      liveFormData:{},
      // 直播已上传文件列表
      uploadLiveFileList:[],
      // 直播规则
      liveRules: {
        title: [
          {required: true, message: '输入视频标题', trigger: 'blur'},
        ],
        time_value: [
          {required: true, message: '选择直播时间', trigger: 'blur'},
        ],
        mobile_alias: [
          {required: true, message: '选择讲师', trigger: 'blur', validator:this.searchLecturerVerify},
        ],
      },
      // 直播流信息，弹窗数据
      dialogliveStreamData:{
        visible: false,
        title: '',
        width: '40%',
        loading: true,
        modal: true
      },
      // 直播流信息
      liveStreamInfo:{}      
    }
  },
  // 计算属性，会监听依赖属性值随之变化
  computed: {
    ...mapGetters(['userPermissions'])
  },
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
// 初始化直播列表
    async initLiveList() {
      this.loadingStaus = true
      let {list}= await this.$api.getCourseLiveList(this.courseId)
      this.liveList=list
      this.$nextTick(() => {
        this.loadingStaus = false
      }) 
    },
    // 初始化直播form数据
    initLiveFormData() {
      // 初始化form表单
      this.$nextTick(() => {
        this.liveDrawerData.visible = false
        this.liveDrawerData.loading = true
        this.liveFormData = {}
        this.$refs['liveForm'].resetFields()
      })
    },
    // 直播封面上传成功回调
    handleLiveUploadSuccess(file, fileList) {
      this.liveFormData.cover = file.id
      this.uploadLiveFileList = fileList
    },
    // 直播封面删除回调
    handleLiveUploadRemove(file, fileList) {
      this.liveFormData.cover = 0
      this.uploadLiveFileList = fileList
    },
    // 搜索用户,qs请求参数，cb回调函数，详见组件用法
    async searchLecturer(qs, cb) {
      let list = await this.$api.courseLiveSearchLecturer(qs)
      cb(list)
    },
    // 处理搜索结果的选中
    handleLecturerSelect(item) {
      this.liveFormData.lecturer_id = item.id
      if (this.liveFormData.lecturer_id) {
        this.$refs['liveForm'].validateField('mobile_alias')
      }
    },
    // 直播初始化选择验证
    initMobileVerify() {
      this.liveFormData.lecturer_id = ''
      this.$refs['liveForm'].validateField('mobile_alias')
    },
    // 搜索用户验证
    searchLecturerVerify(rule, value, callback) {
      if (rule.required && !this.liveFormData.lecturer_id) {
        callback(new Error(rule.message))
      }
      callback()
    },
    // 添加直播
    addLive() {
      this.liveDrawerData.loading_text = '玩命加载中……'
      this.liveDrawerData.visible = true
      this.liveDrawerData.title = '添加直播'
      this.liveFormData.course_id = this.courseId
      this.uploadLiveFileList =[]
      this.$nextTick(() => {
        this.liveDrawerData.loading = false
      })
    },
    // 编辑直播
    async editLive(id) {
      this.liveDrawerData.loading_text = '玩命加载中……'
      this.liveDrawerData.visible = true
      this.liveDrawerData.title = '编辑直播'
      let {info} = await this.$api.getCourseLiveInfo(id)
      this.liveFormData = info
      this.uploadLiveFileList = info.image_info.id?[{id:info.image_info.id,name:info.image_info.title,url:info.image_info.full_path}]:[]
      this.liveDrawerData.loading = false
    },
    // 删除直播
    async deleteLive(id) {
      let info = await this.$api.deleteCourseLiveInfo(id)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.initLiveList()
        })
      } else {
        this.$notify.error(info)
      }
    },
    // 处理直播抽屉关闭
    liveDrawerClose() {
      this.initLiveFormData()
    },
    // 处理直播抽屉确认
    async liveDrawerConfirm() {
      // 调用组件的数据验证方法
      this.$refs['liveForm'].validate((valid) => {
        if (valid) {
          this.liveFormSubmit()
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    },
    // 直播信息提交，请求接口
    async liveFormSubmit() {
      let id = await this.$api.saveCourseLive(this.liveFormData)
      if (id) {
        this.initLiveList()
      }
      this.initLiveFormData()
      this.$notify.success('直播信息保存成功!')
    },
    // 判断是否可以被托转
    handleLiveAllowDrop(dragging, drop) {
      if (dragging.level === drop.level) {
        return true
      }
      return false
    },
    // 处理直播节点拖拽完成，前端效果结束且成功后执行，不使用组件回调参数，功能判断放到后端
    async handleLiveNodeDrop() {
      let info = await this.$api.orderCourseLive(this.liveList)
      if (info == 'ok') {
        this.$nextTick(() => {
          this.initLiveList()
        })
        this.$notify.success('排序成功！')
      } else {
        this.initLiveList()
        this.$notify.error(info)
      }
    },
    // 获取直播信息，推流播放等信息
    async getLiveStreamInfo(id) {
      this.dialogliveStreamData.visible = true
      this.dialogliveStreamData.title = '直播流信息'
      let {info} = await this.$api.getCourseLiveStreamInfo(id)
      this.liveStreamInfo = info
      this.dialogliveStreamData.loading = false
    },
    // 直播信息模态框事件
    dialogliveStreamButton() {
      this.dialogliveStreamData.visible = false
      this.dialogliveStreamData.loading = true
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.initLiveList()
  }
}
</script>

<style lang='stylus'>
  .tab-pane-body-live
    .el-tree-node__expand-icon
      margin 0px
      width 0px
      height 0px
      padding 0px !important
      overflow hidden
    .el-tree i
      margin-right 0px !important
  .live-tree-node
    line-height 40px
    width 100%
    span
      margin-right 8px
    .el-button i
      margin-right 0px
    .el-button--mini
      padding 7px 8px
    .live-node
      font-size 14px
      .right
        float right
        span
          margin-right 0px
  .live-time-tag
    font-size 10px
    background-color #1c84c6
    color #FFFFFF
    border-radius 10px
    padding 2px 8px
  .live-lecturer-user input,.live-datetimerange
    width 447px !important
  .live-stream
    margin-bottom 24px
    padding 0px 8px
    border-left 4px solid #179aff
    span
      display block
      padding-bottom 2px
      margin-bottom 8px
      border-bottom 1px solid #e8e8e8  
</style>